import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';
import { StoreService } from 'src/app/services/store.service';
import { AlertComponent } from '../alert/alert.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  clientForm!: FormGroup;
  rol: number = 0;
  countries: any[]=[];
  salaries: any[]=[];
  heritages: any[]=[];
  incomes: any[]=[];
  loader: boolean = false;

  constructor(
    private dialog: MatDialog,
    private adminservice: AdminService,
    private dialogRef: MatDialogRef<AddUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    // private imageCompress: NgxImageCompressService
    private storeservice: StoreService,
    private datepipe: DatePipe
  ) {}

  ngOnInit() {
    this.rol = +this.storeservice.getProfile.rol_id;
    // this.rol = +this.storeservice.getProfile.rol_id;
    this.formBuilder();
    this.getCountries();
    this.getSalaries();
    this.getHeritages();
    this.getIncomes();
    if (this.data?.clientId > 0) {
      this.clientForm.patchValue(this.data);
    }
  }

  formBuilder(){
    this.clientForm = new FormGroup({
      clientId: new FormControl(0),
      fullname: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      city: new FormControl(''),
      address: new FormControl(''),
      phone: new FormControl(''),
      email: new FormControl(''),
      fecnac: new FormControl(''),
      numHijos: new FormControl(''),
      enterprise: new FormControl(''),
      salary: new FormControl(''),
      heritage: new FormControl(''),
      income: new FormControl([]),
    });
  }

  saveClient(){
    if (!this.clientForm.valid) {
      this.dialog.open(AlertComponent,{
        width: '776px',
        disableClose: true,
        data: {
          type: 'success',
          title: 'Mensaje del sistema',
          description: 'Por favor, debe completar los campos que son obligatorios.',
          textButton: 'Entendido'
        }
      });
      return
    }

    let fecPattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!fecPattern.test(this.clientForm.value.fecnac) && this.clientForm.value.fecnac) {
      this.dialog.open(AlertComponent,{
        width: '776px',
        disableClose: true,
        data: {
          type: 'success',
          title: 'Mensaje del sistema',
          description: 'La fecha de nacimiento debe contener el formato dd/mm/aaaa. Corrija el campo por favor',
          textButton: 'Entendido'
        }
      });
      return
    }

    const request = {
      cliente_id: this.clientForm.value.clientId, 
      nombre_completo: this.clientForm.value.fullname,
      pais_id: this.clientForm.value.country,
      ciudad: this.clientForm.value.city,
      direccion: this.clientForm.value.address,
      telefono: this.clientForm.value.phone,
      correo: this.clientForm.value.email,
      fec_nacimiento: this.clientForm.value.fecnac ? `${this.clientForm.value.fecnac.split('/')[2]}-${
        this.clientForm.value.fecnac.split('/')[1]
      }-${this.clientForm.value.fecnac.split('/')[0]}` : '',
      num_hijos: this.clientForm.value.numHijos,
      empresa: this.clientForm.value.enterprise,
      cant_ingreso_id: this.clientForm.value.salary,
      cant_patrimonio_id: this.clientForm.value.heritage,
      tipo_ingreso: this.incomes.filter((element:any)=>element.checked).map((element:any)=>(element.id))
    }
    
    this.loader = true;
    this.adminservice.saveClient(request).pipe(
      finalize(()=>{
        this.loader = false;
      })
    ).subscribe(
      (response)=>{
        this.dialogRef.close(true);
        if (response.rtn && response.result != -1) {
          this.dialog.open(AlertComponent,{
            width: '776px',
            disableClose: true,
            data: {
              type: 'success',
              title: 'Operación exitosa',
              description: 'Se ha creado el cliente correctamente.',
              textButton: 'Entendido'
            }
          });
        }else {
          this.dialogRef.close(false);
          this.dialog.open(AlertComponent,{
            width: '776px',
            disableClose: true,
            data: {
              type: 'error',
              title: 'Ocurrió un error',
              description: 'No se ha podido crear el cliente. Ya existe un usuario con el teléfono y/o correo ingresado.',
              textButton: 'Entendido'
            }
          });
        }
      }
    );
  }

  getCountries(){
    this.adminservice.getCountries().subscribe(
      (response)=>{
        if (response.rtn && response.result) {
          this.countries = response.result;
        }
      }
    );
  }

  getSalaries(){
    this.adminservice.getSalaries().subscribe(
      (response)=>{
        if (response.rtn && response.result) {
          this.salaries = response.result;
        }
      }
    );
  }

  getHeritages(){
    this.adminservice.getHeritages().subscribe(
      (response)=>{
        if (response.rtn && response.result) {
          this.heritages = response.result;
        }
      }
    );
  }

  getIncomes(){
    this.adminservice.getIncomes().subscribe(
      (response)=>{
        if (response.rtn && response.result) {
          this.incomes = response.result;
          this.incomes.forEach((element:any)=> element.checked = false);

          //set checkbox
          this.incomes.forEach((element:any)=>{
            this.data?.income.forEach((item:any)=>{
              if (element.id == item.tipo_ingreso_id) {
                element.checked = true;
              }
            })
          })
        }
      }
    );
  }

  keypressNumbers(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
